import { gql } from "@apollo/client";


export const TRANSLATE_ITEMS = gql`
    mutation TranslateItems($input: TranslationInput!) {
        translateItems(input: $input) {
            items {
                key
                text_translated
            }
        }
    }
`;
